// src/pages/Terms.jsx
import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import TermsBanner from "../components/TermsBanner"; // Banner for Terms

import Footer from "../components/Footer";
import TermsOfUse from "../components/TermsOfUse";

const Terms = () => {
  return (
    <>
      <CustomNavbar />
      <TermsBanner />
      <TermsOfUse/>
      <Footer />
    </>
  );
};

export default Terms;
